export const PUBLIC_ASSETS = {
  PNG: {
    BG_CSAT: '/png/bg-csat.png',
    LOGO_NOLIMIT: '/png/logo-nolimit.png',
    LOGO_NOLIMIT_CARE: '/png/nolimit-care.png',
  },

  SVG: {
    LOGO_REACTJS: '/svg/react.svg',
    LOGO_VITE: '/svg/vite.svg',
  },

  AUDIO: {
    NOTIF_1: '/mp3/notif-1.mp3',
    NOTIF_2: '/mp3/notif-2.wav',
    NOTIF_3: '/mp3/notif-3.mp3',
  },
};

export const CHANNEL_ICONS = {
  DEFAULT: '/channels/default.png',
  WHATSAPP: '/channels/whatsapp.png',
  INSTAGRAM: '/channels/instagram.png',
  FACEBOOK: '/channels/facebook.png',
  TWITTER: '/channels/twitter.png',
  EMAIL: '/channels/email.png',
  LINE: '/channels/line.png',
  SHOPEE: '/channels/shopee.png',
  TOKOPEDIA: '/channels/tokopedia.png',
  TIKTOK: '/channels/tiktok.png',
  GOOGLE_REVIEW: '/channels/google-review.png',
};
